<template>
  <div class="card" :style="`width:${cWidth}`" @click="toJgList">
    <div class="flex-between-left">
      <div class="img flex-center">
        <img :src="cData.imageUrl" />
      </div>
      <div style="flex: 1">
        <div class="jie_shao line">{{ cData.name }}</div>
        <div class="xiang_mu">项目数：<span>{{cData.total}}</span></div>
        <div class="biao_qian flex-left flex-wrap">
          <div v-for="item,index in cData.labelValues" :key="index">{{item}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cWidth: {
      type: String,
      default: "430px",
    },
    cData: {
      // type: Object,
      // default: () => {
      //   return {};
      // },
    },
  },
  data() {
    return {};
  },
  methods: {
    toJgList() {
      this.$router.push(`/seemore?jgId=${this.cData.id}`);
    },
  },
};
</script>

<style lang="scss">
.card {
  padding: 20px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid #e5e6eb;
  cursor: pointer;
  .biao_qian {
    padding-top: 4px;
    & > div {
      height: 20px;
      background: #f2f3f5;
      border-radius: 2px 2px 2px 2px;
      padding: 0 6px;
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      color: #1d2129;
      margin: 8px 8px 0 0;
    }
  }
  .jie_shao {
    font-size: 18px;
    font-weight: 500;
    color: #1d2129;
    line-height: 26px;
    margin-bottom: 2px;
  }
  .xiang_mu {
    font-size: 14px;
    font-weight: 400;
    color: #86909c;
    line-height: 22px;
    span {
      color: #1d2129;
    }
  }
  .img {
    width: 83px;
    height: 83px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e5e6eb;
    margin-right: 16px;
    img {
      width: 100%;
      max-height: 100%;
    }
  }
}
</style>
